import omitBy from 'lodash/omitBy';

export default function removeFiltersFromQuery(query, prefix) {
  return omitBy(query, (value, key) => key.indexOf(prefix) === 0);
}
